import { object, string, array, number, boolean, lazy } from '@gogame/schemas';

export const notificationsSettingsSchema = object({
  eventGroups: array().of(
    object().shape({
      id: number(),
      events: array().of(
        lazy((obj) =>
          object().shape({
            id: number(),
            name: string().test('', 'At least 1 required', () => {
              return (
                !obj.required ||
                (obj.required &&
                  obj.channels.some((channel) => channel.checked))
              );
            }),
            channels: array().of(
              object().shape({
                checked: boolean(),
              })
            ),
          })
        )
      ),
    })
  ),
});
